import { CSSProperties } from 'styled-components';

export const DataTable: CSSProperties = {
    width: '100%',
};

export const DataTableHeader: CSSProperties = {
    borderBottom: '2px solid #000',
};

export const DataTableHeaderColumn: CSSProperties = {
    borderBottom: '2px solid #000',
    height: '50px',
    padding: '0 15px',
    fontSize: '11px',
    fontWeight: '600',
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
};

export const DataTableRow: CSSProperties = {
    borderBottom: '1px solid #000',
};

export const DataTableCell: CSSProperties = {
    borderBottom: '1px solid #000',
    padding: '5px 15px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: '12px',
    lineHeight: '1.67',
};

export const Name: CSSProperties = {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '5px',
};

export const Company: CSSProperties = {
    fontSize: '14px',
    fontWeight: '600',
    textTransform: 'uppercase',
    marginBottom: '20px',
    display: 'inline-block',
};

export const Date: CSSProperties = {
    display: 'inline-block',
    fontSize: '14px',
    paddingLeft: '20px',
};

export const Filter: CSSProperties = {
    fontSize: '13px',
    paddingBottom: '10px',
};

export const Logo: CSSProperties = {
    position: 'absolute',
    width: '124px',
    height: '24px',
    right: '60px',
    top: '60px',
};
